<fieldset>
  <label [raskRequired]="required">
    {{label}}
    @if (infoText) {
      <rask-info>{{infoText}}</rask-info>
    }
  </label>
  <div class="wrapper" [ngClass]="{'unit': unit}">
    <div class="d-flex">
      @if (inputGroup) {
        <span class="input-group-text">{{inputGroup}}</span>
      }
      @if (!showCustomInput) {
        <input
          id="{{aid}}"
          [min]="min"
          [step]="step"
          [max]="max"
          type="number"
          [placeholder]="placeholder"
          [(ngModel)]="value"
          [ngModelOptions]="{standalone: true}"
          [disabled]="disabled"
          (drop)="onDrop($event)"
          (paste)="onPaste($event)"
          (keypress)="onKeypress($event)">
      } @else {
        <input
          id="{{aid}}"
          [placeholder]="placeholder"
          [(ngModel)]="customValue"
          [ngModelOptions]="{standalone: true}"
          [disabled]="disabled"
          (ngModelChange)="customValueChange($event)"
          (drop)="onDrop($event)"
          (paste)="onPaste($event)"
          (keypress)="onKeypress($event)">
        }


        @if (unit) {
          <div class="unit">{{unit}}</div>
        }
        @if (inputGroupRight) {
          <span class="input-group-text input-group-right">{{inputGroupRight}}</span>
        }
      </div>
    </div>
    @if (rule) {
      <rask-validation-message [rule]="rule"></rask-validation-message>
    }
  </fieldset>